import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CidadeComponent } from './cidade/cidade.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EnderecoService } from './endereco.service';
import { ConfirmationService } from 'primeng/api';



@NgModule({
  declarations: [CidadeComponent],
  providers:[EnderecoService, ConfirmationService],
  exports:[CidadeComponent],
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ToolbarModule,
    CardModule,
    FileUploadModule,
    DialogModule,
    ConfirmDialogModule
  ]
})
export class EnderecoModule { }
